import React, { Component } from "react";
import "./DeleteQueryModal.scss";
import Modal from "../../../../../components/UIComponents/CustomModal/Modal";
export default class DeleteQueryModal extends Component {
    constructor(props) {
        super(props);
    }
    onCancel = () => {
        this.props.handleClose();
    };
    onDeleteQuery = () => {
        let deletingQuery = this.props.queryToBeDeleted;
        this.props.deleteSubtopicWithQuery(deletingQuery);
    };
    render() {
        const deletingQuery = this.props.queryToBeDeleted;
        let query = "";
        if (Object.keys(deletingQuery ?? []).length !== 0) {
            query = deletingQuery.subtopic_name;
        }
        return (
            <Modal className="deleteQueryModal" show={this.props.open} onClose={this.onCancel}>
                <Modal.Header>Delete Query</Modal.Header>
                <Modal.Content className="delete__query-content">
                    <p className="label">
                        Are you sure want to delete the <span className="query-to-be-deleted">{query}</span> from Queries list? You will not be able to recover
                        them.
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton
                        normal
                        onClick={() => {
                            this.onCancel();
                        }}>
                        Cancel
                    </Modal.ActionButton>
                    <Modal.ActionButton filled onClick={() => this.onDeleteQuery()}>
                        Delete
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    }
}
